export const QUERY_KEY_CHAT = 'chat';
export const QUERY_KEY_HINT = 'hint';
